import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import Icon from '../../Icon';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import {
  Status,
  ReturnFormActions,
  ReturnItemProps,
  submitImage,
} from '../../../Reducers/ReturnForm.reducer';
import LoadingSpinner from '../../LoadingSpinner';
import { translate } from '../../../Services/translation';

const MAX_FILE_SIZE = 500000000;

const ReturnFormMediaInput = ({ item }: { item: ReturnItemProps }) => {
  const dispatch = useDispatch();

  const onDrop = useCallback((acceptedFiles: File[]) => {
    if (acceptedFiles.length == 0) return;

    const formData = new FormData();
    acceptedFiles.map((file, idx) => {
      formData.append('imageUpload' + idx, file);
    });

    dispatch(submitImage({ form: formData, id: item.uniqueId }));
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'image/jpeg': [], 'image/png': [], 'video/mp4': [] },
    minSize: 0,
    maxSize: MAX_FILE_SIZE,
  });

  const { imageStatus } = item;

  useEffect(() => {
    if (imageStatus !== Status.idle && imageStatus !== Status.pending) {
      setTimeout(() => {
        dispatch(
          ReturnFormActions.setImageStatus({
            status: Status.idle,
            id: item.uniqueId,
          })
        );
      }, 1500);
    }
  }, [imageStatus]);

  const renderMediaContent = useCallback(() => {
    switch (imageStatus) {
      case Status.idle:
        return (
          <>
            <input {...getInputProps()} type="file" />
            <Icon name="images" className="h-14 w-14" />
            <p className="text-md font-bold text-gray-700">
              {translate('return.form-item.media-add')}
            </p>
            <p className="text-md font-light text-gray-700">
              {translate('return.form-item.media-drag')}
            </p>
          </>
        );
      case Status.pending:
        return <LoadingSpinner />;
      case Status.fulfilled:
        return <Icon name="check" className="h-10 w-10" />;
      case Status.rejected:
        return <Icon name="close" className="h-10 w-10" />;
      default:
        return null;
    }
  }, [imageStatus]);

  return (
    <div
      className={clsx(
        isDragActive ? 'bg-success-200' : 'bg-success-50',
        'col-span-full flex min-h-[130px] flex-col items-center justify-center  rounded border-2 border-dashed border-gray-200  px-2 pb-4 pt-3 text-center'
      )}
      {...getRootProps()}
    >
      {renderMediaContent()}
    </div>
  );
};

export default ReturnFormMediaInput;
